


























import { Component, Vue } from "vue-property-decorator";

@Component
export default class RedirectToLoginOrOldPeak extends Vue {
  private widthScreen = 0;

  mounted() {
    this.widthScreen = window.innerWidth;
    window.addEventListener("resize", () => {
      this.widthScreen = window.innerWidth;
    });
  }

  public RedirectToLogin() {
    location.replace(process.env.VUE_APP_PeakAccount);
  }
}
